var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true}}],staticClass:"shop-container"},[_c('div',{staticClass:"tab"},[_c('i',[_vm._v(_vm._s(_vm.$t('Details')))])]),_c('div',{staticClass:"det-con"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.pageData.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }